// прелоадер
function preloader() {
  const preloader = document.querySelector('.loader');
  if (preloader) {
    if (preloader) {
      function preloadOnly() {
        window.scrollTo(0, 0);

        let images = document.images,
          imagesTotalCount = document.images.length,
          imagesLoadedCount = 0;
        for (let i = 0; i < imagesTotalCount; i++) {
          let image_Clone = new Image();
          image_Clone.onload = imageLoaded;
          image_Clone.oneerorr = imageLoaded;
          image_Clone.src = images[i].src;

        }

        function imageLoaded() {
          imagesLoadedCount++;


          if (imagesLoadedCount >= imagesTotalCount) {

            setTimeout(() => {
              preloader.classList.add("loaded");
            }, 1500)

          }
        }
      }

      function preloadEvery() {
        window.scrollTo(0, 0);
        preloader.style.display = 'none';


      }

      const t = sessionStorage.getItem('doNotShow1');

      if (!sessionStorage.getItem('doNotShow1')) {
        sessionStorage.setItem('doNotShow1', 'true');
        preloadOnly()
      } else {
        preloadEvery()

      }

    }
  }
}

export default preloader







